export default "__VITE_ASSET__9UGNcpNR4$BBcibppkPN7g__"